"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDeleteWorkout = void 0;
exports.deleteWorkoutSetMock = deleteWorkoutSetMock;
exports.deleteWorkout = deleteWorkout;
exports.useMutationDeleteWorkout = useMutationDeleteWorkout;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function deleteWorkoutSetMock(mock) {
    setMock = mock;
}
async function deleteWorkout(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/workout-store/${params.version}/workouts/${params.id}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if (params['X-Llama-Namespaces'] !== undefined) {
        headers['X-Llama-Namespaces'] = params['X-Llama-Namespaces'];
    }
    if (params['X-Llama-Log-Level'] !== undefined) {
        headers['X-Llama-Log-Level'] = params['X-Llama-Log-Level'];
    }
    if (params['Cache-Control'] !== undefined) {
        headers['Cache-Control'] = params['Cache-Control'];
    }
    if (params.Accept !== undefined) {
        headers.Accept = params.Accept;
    }
    if ((params.forceStatusCheck) && (await (0, is_down_1.workoutStoreIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'DELETE', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyDeleteWorkout = 'workout-store:deleteWorkout:delete';
function useMutationDeleteWorkout(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyDeleteWorkout }, mutationOptions));
}
function mutationFn({ params }) {
    const promise = deleteWorkout(params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=delete-workout.js.map